import {Component, inject, OnInit} from '@angular/core';
import {ModalWindowComponent} from "../../../std-components/modal-window/modal-window.component";
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {
  IBuildingRoomTypeItem,
  ISetBuildingRoomValues,
  StagingService
} from "../../../new-information/services/staging.service";
import {finalize} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {RoomTypeEnum} from "../../../shared/models/models";
import {NgxMaskDirective, provideNgxMask} from "ngx-mask";


@Component({
  selector: 'app-create-commercial2',
  templateUrl: './create-commercial2.component.html',
  styleUrl: './create-commercial2.component.scss',
  imports: [
    ModalWindowComponent,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMaskDirective,
    MatDialogClose,
  ],
  providers: [
    provideNgxMask()
  ],
  standalone: true
})
export class CreateCommercial2Component implements OnInit {
  readonly dialogRef = inject(MatDialogRef<CreateCommercial2Component>);
  readonly data = inject<{ room: ISetBuildingRoomValues }>(MAT_DIALOG_DATA);


  form = new FormGroup({
    buildingID: new FormControl(),
    buildingRoomID: new FormControl(),
    roomTypeItemID: new FormControl(),
    entrance: new FormControl(),
    floorID: new FormControl(),
    placeNumber: new FormControl(),
    area: new FormControl(),
    roomTypeItemTitle: new FormControl(),
  });

  roomTypes: IBuildingRoomTypeItem[] = [];
  loading = false;

  constructor(private stagingService: StagingService,
              private toastr: ToastrService) {
  }

  ngOnInit() {
    this.loading = true;
    this.stagingService.getBuildingRoomTypeItems(RoomTypeEnum.Commercial)
      .pipe(
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (res) => {
          this.roomTypes = res;
          this.form.patchValue(this.data.room);
        },
        error: (err) => {
        },
      });
  }


  loadingSave = false;
  save() {
    this.loadingSave = true;
    console.log(this.form);
    const object: ISetBuildingRoomValues = this.form.value as ISetBuildingRoomValues;
    console.log(object, 'object');
    this.stagingService.setBuildingRoomValues(object)
      .pipe(
        finalize(() => this.loadingSave = false)
      )
      .subscribe({
      next: (res) => {
        console.log(res, 'res')
        this.toastr.success('Изменения сохранены!', 'Успешно!');
        this.dialogRef.close(this.form.value);
      },
      error: (err) => {
        console.log(err)
      },
    })
  }

  changeRoomType(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.form.get('roomTypeItemTitle').setValue(this.roomTypes.find(item => item.id === +selectedValue).title);
  }


}
